import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CompanyDTO } from '@app/shared/services/dtos/company/company.dto';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CompaniesHttpService {
  private readonly httpClient = inject(HttpClient);
  private readonly base = environment.APIEndPoint;

  public getCompaniesForCooperation(companyId: string): Observable<CompanyDTO[]> {
    return this.httpClient.get<CompanyDTO[]>(`${this.base}companies/${companyId}/companies-for-cooperation`);
  }
}
